import React from "react";

export const PinPurpleIcon = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M20.1583 8.77778C20.1583 4.2737 16.4979 0.613281 11.9938 0.613281C7.48976 0.613281 3.82935 4.2737 3.82935 8.77778C3.82935 14.9012 11.9938 23.746 11.9938 23.746C11.9938 23.746 20.1583 14.9012 20.1583 8.77778V8.77778Z"
                fill="url(#paint0_linear_756_26679)"
            />
            <path
                opacity="0.4"
                d="M7.5 9C7.5 6.1125 9.8625 3.75 12.75 3.75C15.6375 3.75 18 6.1125 18 9C18 11.8875 15.6638 14.25 12.75 14.25C9.8625 14.25 7.5 11.8875 7.5 9V9Z"
                fill="white"
            />
            <path
                d="M7.5 9C7.5 6.525 9.525 4.5 12 4.5C14.475 4.5 16.5 6.525 16.5 9C16.5 11.475 14.4975 13.5 12 13.5C9.525 13.5 7.5 11.475 7.5 9V9Z"
                fill="white"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_756_26679"
                    x1="11.5273"
                    y1="-2.94904"
                    x2="11.5273"
                    y2="23.746"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF9A93" />
                    <stop offset="1" stopColor="#9D65E6" />
                </linearGradient>
            </defs>
        </svg>
    );
};

export const PinPinkIcon = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M20.1583 8.77778C20.1583 4.2737 16.4979 0.613281 11.9938 0.613281C7.48976 0.613281 3.82935 4.2737 3.82935 8.77778C3.82935 14.9012 11.9938 23.746 11.9938 23.746C11.9938 23.746 20.1583 14.9012 20.1583 8.77778Z"
                fill="#F2939F"
            />
            <path
                opacity="0.4"
                d="M7.5 9C7.5 6.1125 9.8625 3.75 12.75 3.75C15.6375 3.75 18 6.1125 18 9C18 11.8875 15.6637 14.25 12.75 14.25C9.8625 14.25 7.5 11.8875 7.5 9Z"
                fill="white"
            />
            <path
                d="M7.5 9C7.5 6.525 9.525 4.5 12 4.5C14.475 4.5 16.5 6.525 16.5 9C16.5 11.475 14.4975 13.5 12 13.5C9.525 13.5 7.5 11.475 7.5 9Z"
                fill="white"
            />
        </svg>
    );
};

export const PinGreenIcon = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M20.1583 8.77778C20.1583 4.2737 16.4979 0.613281 11.9938 0.613281C7.48976 0.613281 3.82935 4.2737 3.82935 8.77778C3.82935 14.9012 11.9938 23.746 11.9938 23.746C11.9938 23.746 20.1583 14.9012 20.1583 8.77778Z"
                fill="url(#paint0_linear_756_26622)"
            />
            <path
                opacity="0.4"
                d="M7.5 9C7.5 6.1125 9.8625 3.75 12.75 3.75C15.6375 3.75 18 6.1125 18 9C18 11.8875 15.6637 14.25 12.75 14.25C9.8625 14.25 7.5 11.8875 7.5 9Z"
                fill="white"
            />
            <path
                d="M7.5 9C7.5 6.525 9.525 4.5 12 4.5C14.475 4.5 16.5 6.525 16.5 9C16.5 11.475 14.4975 13.5 12 13.5C9.525 13.5 7.5 11.475 7.5 9Z"
                fill="white"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_756_26622"
                    x1="3.82935"
                    y1="12.1797"
                    x2="20.1583"
                    y2="12.1797"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#99D0C8" />
                    <stop offset="1" stopColor="#7CAE7B" />
                </linearGradient>
            </defs>
        </svg>
    );
};

export const PinOrangeIcon = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M20.1583 8.77778C20.1583 4.2737 16.4979 0.613281 11.9938 0.613281C7.48976 0.613281 3.82935 4.2737 3.82935 8.77778C3.82935 14.9012 11.9938 23.746 11.9938 23.746C11.9938 23.746 20.1583 14.9012 20.1583 8.77778Z"
                fill="url(#paint0_linear_756_26633)"
            />
            <path
                d="M11.9938 22.9958C11.7749 22.7463 11.4686 22.3909 11.1033 21.9496C10.3446 21.0327 9.33377 19.748 8.32396 18.2754C7.31318 16.8013 6.30973 15.1481 5.56053 13.4936C4.80848 11.8328 4.32935 10.2069 4.32935 8.77778C4.32935 4.54984 7.7659 1.11328 11.9938 1.11328C16.2218 1.11328 19.6583 4.54984 19.6583 8.77778C19.6583 10.2069 19.1792 11.8328 18.4272 13.4936C17.678 15.1481 16.6745 16.8013 15.6637 18.2754C14.6539 19.748 13.6431 21.0327 12.8843 21.9496C12.5191 22.3909 12.2128 22.7463 11.9938 22.9958Z"
                stroke="white"
                strokeOpacity="0.05"
            />
            <path
                opacity="0.4"
                d="M7.5 9C7.5 6.1125 9.8625 3.75 12.75 3.75C15.6375 3.75 18 6.1125 18 9C18 11.8875 15.6637 14.25 12.75 14.25C9.8625 14.25 7.5 11.8875 7.5 9Z"
                fill="white"
            />
            <path
                d="M7.5 9C7.5 6.525 9.525 4.5 12 4.5C14.475 4.5 16.5 6.525 16.5 9C16.5 11.475 14.4975 13.5 12 13.5C9.525 13.5 7.5 11.475 7.5 9Z"
                fill="white"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_756_26633"
                    x1="-1.35851"
                    y1="-4.56749"
                    x2="27.4188"
                    y2="13.5833"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FBFF2D" />
                    <stop offset="1" stopColor="#FE8228" />
                </linearGradient>
            </defs>
        </svg>
    );
};

export const PinLightGreenIcon = () => {
    return (
        <svg
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M20.6583 8.77778C20.6583 4.2737 16.9979 0.613281 12.4938 0.613281C7.98976 0.613281 4.32935 4.2737 4.32935 8.77778C4.32935 14.9012 12.4938 23.746 12.4938 23.746C12.4938 23.746 20.6583 14.9012 20.6583 8.77778Z"
                fill="url(#paint0_linear_756_26645)"
            />
            <path
                opacity="0.4"
                d="M8 9C8 6.1125 10.3625 3.75 13.25 3.75C16.1375 3.75 18.5 6.1125 18.5 9C18.5 11.8875 16.1637 14.25 13.25 14.25C10.3625 14.25 8 11.8875 8 9Z"
                fill="white"
            />
            <path
                d="M8 9C8 6.525 10.025 4.5 12.5 4.5C14.975 4.5 17 6.525 17 9C17 11.475 14.9975 13.5 12.5 13.5C10.025 13.5 8 11.475 8 9Z"
                fill="white"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_756_26645"
                    x1="12.2595"
                    y1="-2.36738"
                    x2="12.4271"
                    y2="32.903"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#DDED7C" />
                    <stop offset="1" stopColor="#CFFF91" />
                </linearGradient>
            </defs>
        </svg>
    );
};

export const PinBlueIcon = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M20.1581 8.77778C20.1581 4.2737 16.4977 0.613281 11.9936 0.613281C7.48952 0.613281 3.8291 4.2737 3.8291 8.77778C3.8291 14.9012 11.9936 23.746 11.9936 23.746C11.9936 23.746 20.1581 14.9012 20.1581 8.77778Z"
                fill="url(#paint0_linear_756_26656)"
            />
            <path
                d="M11.9936 22.9958C11.7746 22.7463 11.4683 22.3909 11.1031 21.9496C10.3443 21.0327 9.33352 19.748 8.32371 18.2754C7.31293 16.8013 6.30949 15.1481 5.56028 13.4936C4.80824 11.8328 4.3291 10.2069 4.3291 8.77778C4.3291 4.54984 7.76566 1.11328 11.9936 1.11328C16.2215 1.11328 19.6581 4.54984 19.6581 8.77778C19.6581 10.2069 19.179 11.8328 18.4269 13.4936C17.6777 15.1481 16.6743 16.8013 15.6635 18.2754C14.6537 19.748 13.6429 21.0327 12.8841 21.9496C12.5189 22.3909 12.2126 22.7463 11.9936 22.9958Z"
                stroke="white"
                strokeOpacity="0.05"
            />
            <path
                opacity="0.4"
                d="M7.5 9C7.5 6.1125 9.8625 3.75 12.75 3.75C15.6375 3.75 18 6.1125 18 9C18 11.8875 15.6637 14.25 12.75 14.25C9.8625 14.25 7.5 11.8875 7.5 9Z"
                fill="white"
            />
            <path
                d="M7.5 9C7.5 6.525 9.525 4.5 12 4.5C14.475 4.5 16.5 6.525 16.5 9C16.5 11.475 14.4975 13.5 12 13.5C9.525 13.5 7.5 11.475 7.5 9Z"
                fill="white"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_756_26656"
                    x1="5.2749"
                    y1="1.69763"
                    x2="25.4438"
                    y2="16.5853"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#5EB7FF" />
                    <stop offset="1" stopColor="#2D80FF" />
                </linearGradient>
            </defs>
        </svg>
    );
};
